import { Component, Inject, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MemberInsurerRestService } from '../../services/member-insurer-rest.service';
import { CommonModule, DatePipe, NgFor } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { MemberInsurerServiceService } from '../../services/member-insurer-service.service';
import { AddMemberComponent } from '../add-member/add-member.component';
import { ConfirmationmodalComponent } from '../shared/components/confirmationmodal/confirmationmodal.component';
import { NotificationService } from '../shared/services/notifications.service';
import { ConfirmationMode } from '../shared/share';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { CustomDateAdapter } from '../shared/pipes/custom-date-adapter';
import { MY_NATIVE_DATE_FORMATS } from '../shared/pipes/date-format';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { addProviderPayload } from '../../models/phase1models';


@Component({
  selector: 'app-add-medical-provider',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatInputModule, MatFormFieldModule, MatPaginatorModule, MatSortModule, MatTableModule, MatSelectModule, ReactiveFormsModule,
    MatDatepickerModule
  ],
  templateUrl: './add-medical-provider.component.html',
  styleUrl: './add-medical-provider.component.scss',
  providers: [
    DatePipe, // optional, useful if you're formatting dates elsewhere
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_NATIVE_DATE_FORMATS }
  ],
})
export class AddMedicalProviderComponent {
  providerForm: FormGroup;
  popupTitle = 'Add Provider';
  popupSubtitle = 'Please provide the information below to add a new provider.';
  isSubmitLoading: boolean = false;
  today = new Date();
  enumConfirmationMode = ConfirmationMode;
  EditedAgent: any;
  @Input() isDismissable: boolean = false;
  imagePreviewUrl: string | ArrayBuffer | null = null;


  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<AddMemberComponent>, private dialog: MatDialog,
    private restService: MemberInsurerRestService, private memberService: MemberInsurerServiceService, private datepipe: DatePipe,
    private notificationService: NotificationService, @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    if (data) {
      this.EditedAgent = data;
    }

    this.providerForm = this.fb.group({
      name: ['', Validators.required],
      speciality: [''],
      email: ['', [Validators.required, Validators.email]], // ✅ fixed here
      phone: ['', [Validators.required, Validators.pattern(/^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/)]],
      address: ['', Validators.required],
      logoImg: [''],
      yearsOfExperience: [''],
      licenseNumber: [''],
    });

  }

  ngOnInit() {
    if (this.EditedAgent) {
      this.preFillForm(this.EditedAgent);
    }

  }

  previewImage(file: File) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.imagePreviewUrl = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  previewImageby(url: any) {
    this.imagePreviewUrl = url;
  }


  onFileInputClick() {
    console.log("clicked");
    // this.backButton();
  }

  onFileDropped(event: Event) {
    event.preventDefault();
    const dragEvent = event as DragEvent;
    const files = dragEvent.dataTransfer ? dragEvent.dataTransfer.files : null;
    console.log(files);
    if (files && files.length > 0) {
      // this.handleFiles(files);
    }
  }

  fileUploaded: any;
  async onAssetImage(event: any) {
    const file = event.files[0];
    console.log(file);
    this.fileUploaded = file;
    this.previewImage(file);
    if (this.EditedAgent) {
      const url = await this.getfiles3Url(file);
      this.providerForm.get('logoImg')?.patchValue(url.documentPath);
    }
  }

  getfiles3Url(file: File): Promise<any> {
    return new Promise((resolve, reject) => {
      this.restService.uploadFile(file).subscribe(
        (response) => resolve(response),
        (error) => reject(error)
      );
    });
  }


  preFillForm(data: any): void {
    if (data) {
      this.popupTitle = 'Edit Provider';
      this.popupSubtitle = 'Please provide the information below to edit provider.';
      this.previewImageby(data.imgLogoUrl)

      this.providerForm.patchValue({
        name: data.name || '',
        speciality: data.speciality || '',
        email: data.email || '',
        phone: data.contactNumber || '',
        address: data.location || '',
        yearsOfExperience: data.experience || '',
        licenseNumber: data.licenseNumber || ''
      });
    }
  }

  onSubmit() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '350px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;

    const dialogRef = this.dialog.open(ConfirmationmodalComponent, dialogConfig);
    dialogRef.componentInstance.title = 'Confirm';
    dialogRef.componentInstance.mode = this.enumConfirmationMode.ADD;
    dialogRef.componentInstance.message = this.EditedAgent
      ? `Are you sure you want to update agent`
      : `Are you sure you want to add agent`;

    dialogRef.afterClosed().subscribe((isConfirmed: boolean) => {
      if (isConfirmed) {
        this.isSubmitLoading = true;

        if (this.EditedAgent) {
          const { name, phone, email, address, yearsOfExperience, logoImg } = this.providerForm.value;

          const updatePayload: Partial<addProviderPayload> = {
            name: this.providerForm.value.name,
            contactNumber: this.providerForm.value.phone,
            email: this.providerForm.value.email,
            location: this.providerForm.value.address,
            yearsOfExperience: this.providerForm.value.yearsOfExperience,
            logoImg: this.providerForm.value.logoImg || null
          };

          this.restService.updateProvider(updatePayload, this.EditedAgent.masterProviderId).subscribe({

            next: (response) => {
              if (response) {
                this.notificationService.showNotification(`Provider updated successfully. ${response.message}`);
                this.closeDialog();
                this.memberService.setrefreshProviders();
              } else {
                this.notificationService.showNotification(`Failed to update. Please try again.`, 'error');
              }
              this.isSubmitLoading = false;
            },
            error: (error) => {
              this.isSubmitLoading = false;
              this.notificationService.showNotification(error.error?.message || 'An unexpected error occurred.', 'error');
            }
          });

        } else {
          // ✅ ADD case — send FormData with file and full payload
          const formData = new FormData();

          const providerPayload: addProviderPayload = {
            name: this.providerForm.value.name,
            speciality: this.providerForm.value.speciality,
            email: this.providerForm.value.email,
            contactNumber: this.providerForm.value.phone,
            location: this.providerForm.value.address,
            yearsOfExperience: this.providerForm.value.yearsOfExperience,
            logoImg: this.providerForm.value.logoImg || null,
            licenseNumber: this.providerForm.value.licenseNumber,
            addedBy: this.memberService.getLoginUserId()
          };

          formData.append(
            'provider',
            new Blob([JSON.stringify(providerPayload)], { type: 'application/json' })
          );

          if (this.fileUploaded) {
            formData.append('file', this.fileUploaded, this.fileUploaded.name);
          }

          this.restService.addProvider(formData).subscribe({
            next: (response) => {
              if (response) {
                this.notificationService.showNotification(`Provider added successfully. ${response.message}`);
                this.closeDialog();
                this.memberService.setrefreshProviders();
              } else {
                this.notificationService.showNotification(`Failed to add. Please try again.`, 'error');
              }
              this.isSubmitLoading = false;
            },
            error: (error) => {
              this.isSubmitLoading = false;
              this.notificationService.showNotification(error.error?.message || 'An unexpected error occurred.', 'error');
            }
          });
        }

      } else {
        this.providerForm.markAllAsTouched();
      }
    });
  }


  closeDialog() {
    this.dialogRef.close(true)
  }
}
